module.exports = __webpack_public_path__ + "static/media/plus-button_icn.57c0b428.svg";